import Constants from '@/Constants';
import Category, { ActivateCategoryRequest, CreateCategoryRequest, InactivateCategoryRequest } from '@/models/Category';
import http from '@/services/HttpService';
import { getCategoryExistsByTranslationName } from '@/utils/getCategoryExistsByTranslationName';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import {
    activateCategoryFailure,
    activateCategorySuccess,
    createCategoryFailure,
    createCategorySuccess,
    inactivateCategoryFailure,
    inactivateCategorySuccess,
} from './action';
import { CategoryManagementTypes } from './types';

export function* createCategory(action: PayloadAction<CategoryManagementTypes.CREATE_CATEGORY_REQUEST, CreateCategoryRequest>) {
    try {
        yield call(http.post, Constants.CATEGORIES_URI, action.payload);
        yield put(createCategorySuccess());
    } catch (err) {
        const error: any = err;

        if (error.response.status !== Constants.statusCode.ENTITY_ALREADY_EXISTS) {
            yield put(createCategoryFailure(error));
            return;
        }

        const { applicationId, organizationId, categoryTranslations, locale, name } = action.payload;
        const translations = [{ name, locale }, ...categoryTranslations];

        const categoryFound: Category | undefined = yield getCategoryExistsByTranslationName({
            applicationId,
            organizationId,
            translations,
        });

        error.response.data = categoryFound;

        yield put(createCategoryFailure(error));
    }
}

export function* activateCategory(action: PayloadAction<CategoryManagementTypes.ACTIVATE_CATEGORY_RESQUEST, ActivateCategoryRequest>) {
    try {
        yield call(http.put, Constants.CATEGORIES_URI + '/' + action.payload.id + '/activate');
        yield put(activateCategorySuccess());
    } catch (error) {
        yield put(activateCategoryFailure(error as any));
    }
}

export function* inactivateCategory(action: PayloadAction<CategoryManagementTypes.INACTIVATE_CATEGORY_RESQUEST, InactivateCategoryRequest>) {
    try {
        yield call(http.put, Constants.CATEGORIES_CAST_URI + '/' + action.payload.id + '/deactivate');
        yield put(inactivateCategorySuccess());
    } catch (error) {
        yield put(inactivateCategoryFailure(error as any));
    }
}
